import React from 'react';
import PhoneNumberInput from '../Utils/PhoneNumberInput';

interface StorePhoneNumberFieldProps {
  field: any;
  form: any;
  selectedCountryCode: string;
  onCountryCodeChange: (code: string) => void;
}

const StorePhoneNumberField: React.FC<StorePhoneNumberFieldProps> = ({
  field,
  form,
  selectedCountryCode,
  onCountryCodeChange,
}) => (
  <PhoneNumberInput
    field={field}
    form={form}
    selectedCountryCode={selectedCountryCode}
    onCountryCodeChange={onCountryCodeChange}
  />
);

export default React.memo(StorePhoneNumberField); 